/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecentAccess } from '../../models/recent-access';

export interface ServerStatusControllerGetRecentAccess$Params {
  name: string;
}

export function serverStatusControllerGetRecentAccess(http: HttpClient, rootUrl: string, params: ServerStatusControllerGetRecentAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<RecentAccess>> {
  const rb = new RequestBuilder(rootUrl, serverStatusControllerGetRecentAccess.PATH, 'get');
  if (params) {
    rb.path('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecentAccess>;
    })
  );
}

serverStatusControllerGetRecentAccess.PATH = '/server-status/recentAccess/{name}';
